import styles from './calculatorIntro.module.scss';

export const CalculatorIntro = () => {
  return (
    <div className={styles.intro}>
      <h2 className={styles.title}>
        <div className={styles.titleBold}>67% of Canadian dog owners</div>
        <div className={styles.titleText}>
          did not do any financial calculations for ongoing costs before
          committing to a pup
          <span className={styles.asterisk}>*</span>
        </div>
      </h2>
      <div className={styles.text}>
        <p>
          Paction has created the most comprehensive cost calculator yet, and
          it’s based on real 2025 Canadian data on the annual cost of a dog.
          Besides just answering questions on how much a particular breed of dog
          costs, this exercise also helps new dog owners get into the mindset of
          what it will be like to bring home a new furry family member. And, it
          only takes 3 minutes to complete!
        </p>
        <p className={styles.reference}>
          <span className={styles.referenceAsterisk}>*</span>Paction research
          study completed in Winter 2025 with 521 Canadian participants
        </p>
      </div>
    </div>
  );
};
